import React, { useEffect, useState } from "react";
import { IconButton, Popover } from "@mui/material";
import ChatIcon from "assets/images/svg-icons/squareChat.svg";
import ContactIcon from "assets/images/svg-icons/user-profile-black.svg";
import MailIcon from "assets/images/svg-icons/mail-black.svg";
import CalendarIcon from "assets/images/svg-icons/calendar-black.svg";
import GridBoxIcon from "assets/images/svg-icons/gridBoxIcon.svg";
import Grid from "@mui/material/Unstable_Grid2";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MuiBox, MuiTypography } from "components/atoms";
import { urls } from "config/urls";

const HeaderToolsMenu = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const [selectedStatus, setSelectedStatus] = useState("mail");
  const open = Boolean(anchorEl);

  const menuItems = [
    {
      title: t("header.mail"),
      label: "mail",
      icon: MailIcon,
      onClick: () => {
        handleClose();
        window.open(
          `${urls.MAIL_URL}mail/inbox`,
          "_blank",
          "noopener,noreferrer",
        );
      },
    },
    {
      title: t("header.calendar"),
      label: "calendar",
      icon: CalendarIcon,
      onClick: () => {
        handleClose();
        window.open(
          `${urls.MAIL_URL}calendar/calendar`,
          "_blank",
          "noopener,noreferrer",
        );
      },
    },
    {
      title: t("header.chat"),
      label: "chat",
      icon: ChatIcon,
      onClick: () => {
        handleClose();
        window.open(urls.CHAT_URL, "_blank", "noopener,noreferrer");
      },
    },
    {
      title: t("header.contacts"),
      label: "contacts",
      icon: ContactIcon,
      onClick: () => {
        handleClose();
        window.open(
          `${urls.MAIL_URL}contacts/contact`,
          "_blank",
          "noopener,noreferrer",
        );
      },
    },
  ];

  useEffect(() => {
    if (location.pathname.includes("calendar")) {
      setSelectedStatus("calendar");
    } else if (location.pathname.includes("contacts")) {
      setSelectedStatus("contacts");
    } else if (location.pathname.includes("drive")) {
      setSelectedStatus("drive");
    } else {
      setSelectedStatus("mail");
    }
  }, [location]);

  // const handleSelect = (option) => {
  //   setSelectedStatus(option);
  //   handleClose();
  // };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{ width: "20px", height: "20px", p: 0 }}
      >
        <img src={GridBoxIcon} alt="gridBox" className="img-full" />
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        slotProps={{
          paper: {
            sx: {
              borderRadius: 3,
              boxShadow: "0px 4px 16px rgba(0,0,0,0.1)",
              p: "2px",
              mt: "10px",
              border: "4px solid",
              borderColor: "background.gray400",
              height: "fit-content",
            },
          },
        }}
      >
        <Grid container sx={{ width: 230 }}>
          {menuItems.map((item, index) => {
            const isSelected = selectedStatus === item.label;
            return (
              <Grid item xs={6} key={index}>
                <MuiBox
                  onClick={item.onClick}
                  sx={{
                    p: "16px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: "8px",
                    ...(isSelected && {
                      bgcolor: "background.gray200",
                    }),
                    "&:hover": {
                      bgcolor: "background.gray200",
                    },
                  }}
                >
                  <MuiBox sx={{ height: "24px", width: "24px" }}>
                    <img src={item.icon} alt="MailIcon" className="img-full" />
                  </MuiBox>
                  <MuiTypography
                    variant="14"
                    fontWeight="500"
                    color="text.darkBlack"
                  >
                    {item.title}
                  </MuiTypography>
                </MuiBox>
              </Grid>
            );
          })}
        </Grid>
      </Popover>
    </>
  );
};

export default HeaderToolsMenu;
